import i18next, { t } from 'i18next';

type LpFooterProps = {
  facebookLink?: string;
  instagramLink?: string;
  youtubeLink?: string;
  eventCompany?: string | null;
};

export default function LpFooter({ facebookLink, instagramLink, youtubeLink, eventCompany }: LpFooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="foot">
      <div className="wrap foot__row">
        {/* Socials */}
        {(instagramLink || youtubeLink || facebookLink) && (
          <div className="foot__socials">
            {instagramLink && (
              <a href={instagramLink} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
                </svg>
              </a>
            )}
            {youtubeLink && (
              <a href={youtubeLink} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="4" />
                  <path d="m10 9 5 3-5 3z" fill="currentColor" stroke="none" />
                </svg>
              </a>
            )}
            {facebookLink && (
              <a href={facebookLink} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
                  <path d="M15 3h-3a4 4 0 0 0-4 4v3H5v4h3v7h4v-7h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
            )}
          </div>
        )}

        {/* Nav + language */}
        <div className="foot__nav">
          <span className="foot__lang">
            {['en', 'de', 'fr'].map(lang => (
              <button
                key={lang}
                aria-pressed={i18next.language?.startsWith(lang) ? true : false}
                onClick={() => i18next.changeLanguage(lang)}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </span>
          <a href="https://superfans.social/imprint" target="_blank" rel="noopener noreferrer">
            {t('landingPage.v2.footer.imprint')}
          </a>
          <a href="https://superfans.social/privacy-policy" target="_blank" rel="noopener noreferrer">
            {t('landingPage.v2.footer.privacy')}
          </a>
          <a href="https://join.fiesta.club">
            {t('landingPage.v2.footer.allEvents')}
          </a>
        </div>

        {/* Legal */}
        <div className="foot__legal">
          <div className="foot__wordmark">FIESTA</div>
          © {currentYear} Superfans GmbH. All rights reserved.
          {eventCompany && (
            <><br />On behalf of <b>{eventCompany}</b>.</>
          )}
        </div>
      </div>
    </footer>
  );
}
